import { render, staticRenderFns } from "./JudgeResultModal.vue?vue&type=template&id=208d62a3&scoped=true&"
import script from "./JudgeResultModal.vue?vue&type=script&lang=js&"
export * from "./JudgeResultModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208d62a3",
  null
  
)

export default component.exports